
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.5 1.075A6.432 6.432 0 0113.925 7.5 6.432 6.432 0 017.5 13.925 6.433 6.433 0 011.075 7.5 6.433 6.433 0 017.5 1.075m0-1C3.399.075.075 3.399.075 7.5s3.324 7.425 7.425 7.425 7.425-3.324 7.425-7.425S11.601.075 7.5.075z"}}),_c('circle',{attrs:{"cx":"7.5","cy":"5.119","r":"2.701"}}),_c('path',{attrs:{"d":"M11.402 10.61c.105-.164.183-.349.183-.558v-.435c0-.58-.471-1.051-1.051-1.051H4.466c-.579 0-1.05.471-1.05 1.051v.436c0 .209.077.394.183.558l.188.228A4.975 4.975 0 007.5 12.513a4.975 4.975 0 003.714-1.674l.188-.229z"}})])
          )
        }
      }
    